import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/dashboard_elements/certification_summary_chart');
  return response.data;
}

export default {
  index,
};
